import { render } from "./IconVolkswagen.vue?vue&type=template&id=9d79226e"
import script from "./IconVolkswagen.vue?vue&type=script&lang=js"
export * from "./IconVolkswagen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__